function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: ".5",
  y: "2",
  width: "13",
  height: "14",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 2h13v14H.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3a1.5 1.5 0 100 3h2.5v7.5a1.5 1.5 0 003 0V6H11a1.5 1.5 0 000-3H3z"
})), /*#__PURE__*/React.createElement("path", {
  className: styles["black-gif-text"] || "black-gif-text",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3a1.5 1.5 0 100 3h2.5v7.5a1.5 1.5 0 003 0V6H11a1.5 1.5 0 000-3H3z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["black-gif-text"] || "black-gif-text",
  d: "M5.5 6h1V5h-1v1zm0 7.5h-1 1zm3 0h-1 1zm0-7.5V5h-1v1h1zm-6-1.5A.5.5 0 013 4V2A2.5 2.5 0 00.5 4.5h2zM3 5a.5.5 0 01-.5-.5h-2A2.5 2.5 0 003 7V5zm2.5 0H3v2h2.5V5zm1 8.5V6h-2v7.5h2zm.5.5a.5.5 0 01-.5-.5h-2A2.5 2.5 0 007 16v-2zm.5-.5a.5.5 0 01-.5.5v2a2.5 2.5 0 002.5-2.5h-2zm0-7.5v7.5h2V6h-2zM11 5H8.5v2H11V5zm.5-.5a.5.5 0 01-.5.5v2a2.5 2.5 0 002.5-2.5h-2zM11 4a.5.5 0 01.5.5h2A2.5 2.5 0 0011 2v2zM7 4h4V2H7v2zM3 4h4V2H3v2z",
  fill: "#000",
  mask: "url(#a)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  maskUnits: "userSpaceOnUse",
  x: "2.5",
  y: "0",
  width: "13",
  height: "14",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.5 0h13v14h-13z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 1a1.5 1.5 0 100 3h2.5v7.5a1.5 1.5 0 003 0V4H13a1.5 1.5 0 000-3H5z"
})), /*#__PURE__*/React.createElement("path", {
  className: styles["white-gif-text"] || "white-gif-text",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 1a1.5 1.5 0 100 3h2.5v7.5a1.5 1.5 0 003 0V4H13a1.5 1.5 0 000-3H5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["black-gif-text"] || "black-gif-text",
  d: "M7.5 4h1V3h-1v1zm0 7.5h-1 1zm3 0h-1 1zm0-7.5V3h-1v1h1zm-6-1.5A.5.5 0 015 2V0a2.5 2.5 0 00-2.5 2.5h2zM5 3a.5.5 0 01-.5-.5h-2A2.5 2.5 0 005 5V3zm2.5 0H5v2h2.5V3zm1 8.5V4h-2v7.5h2zm.5.5a.5.5 0 01-.5-.5h-2A2.5 2.5 0 009 14v-2zm.5-.5a.5.5 0 01-.5.5v2a2.5 2.5 0 002.5-2.5h-2zm0-7.5v7.5h2V4h-2zM13 3h-2.5v2H13V3zm.5-.5a.5.5 0 01-.5.5v2a2.5 2.5 0 002.5-2.5h-2zM13 2a.5.5 0 01.5.5h2A2.5 2.5 0 0013 0v2zM9 2h4V0H9v2zM5 2h4V0H5v2z",
  fill: "#000",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["black-gif-text"] || "black-gif-text",
  d: "M1 3l2-2v1.5L2 4 1 3zM12.5 6.5l2-2-1-.5-1 .5v2zM8.5 15.5l2-2-1-.5-1 .5v2z",
  fill: "#000"
})));